<template lang="pug">
.main-wrapper
    .nav-wrapper
    //-     Navigation
    .section-gridlines
    full-page#fullpage(:options="fpOptions", ref="fullpage")
        .section.landing
            .main-title
                //- .title
                //-     .sub-heading2
                //-         span.line2
                //-         h2 Influx
                //-         h2.red .Studio
                //- br
                h1 Forget the norms. Create something&nbsp;
                    span.red unique.

                p.page-description 
                    | You'd be surprised what you can accomplish after long hours and lost of coffee.
                    | We certainly were. Whether it is an interface design you need for your app or
                    | your website, an advertisement or a full-blown move or even a game, chances are
                    | we will create something that will blow your mind.

                .project-menu
                    .menu-item
                        a.label.active(
                            @click="scrollTo('mobile')",
                            data-cursor-shrink
                        ) 01 Mobile Design
                    .menu-item
                        a.label(@click="scrollTo('web')", data-cursor-shrink) 02 Web Design
                    .menu-item
                        a.label(
                            @click="scrollTo('production')",
                            data-cursor-shrink
                        ) 03 Film Production
                    .menu-item
                        a.label(
                            @click="scrollTo('development')",
                            data-cursor-shrink
                        ) 04 Game Development

            VCol.service-images(
                :variants="['xs-12', 'xs-first', 'lg-7', 'lg-last']"
            )
                .service-images-wrapper(ref="parallax")
                    //- .layer-gridlines(data-depth="0.05")
                    //-     img(src="@/assets/images/Works Page/Layer-Lines.png")
                    .layer-graphics(data-depth="0.1")
                        img(
                            src="@/assets/images/Works Page/Banner-Graphics.png"
                        )
                    .layer-images(data-depth="0.25")
                        img(src="@/assets/images/Works Page/Banner-Photos.png")
                    .layer-labels(data-depth="0.45")
                        img(
                            src="@/assets/images/Works Page/Banner-Labels-BG.png"
                        )
                    .layer-labels-text(data-depth="0.45")
                        img(
                            src="@/assets/images/Works Page/Banner-Labels-FG.png"
                        )

            //- .title-section-image(ref="parallax")
            //-     img.dot-pattern(src="@/assets/dot-pattern-2.svg", data-depth="0.2")
            //-     img.main-image(src="@/assets/images/teammembers.jpg", data-depth="0.2")
            //-     .outline-square(data-depth="0.2")

        #mobiledesign.section.white(data-anchor="mobile")
            .title
                .sub-heading
                    span.line
                    h2 mobile&nbsp;
                        span.red design
                h1 Increase sales with&nbsp;
                    span.red meticulously designed&nbsp;
                    span mobile interfaces.
                    //- h2.red .design
                //- .description
                    p Please work
                p.description We travel beyond normal practices and set standards for what works and what doesn't. Our mobile applications, whether native or web-based are sure to give your audience the best experience they could ask for.
            .examples
                .preview
                    router-link.img-wrapper(:to="{ name: 'bean' }")
                        img(
                            src="@/assets/images/preview-mobile-1.png",
                            data-cursor-shrink
                        )
                    h1 Bean
                    p An app by students for students to revolutionise the way students are focusing on their studies and how they can better cope with their mental health.
                .preview
                    router-link.img-wrapper(:to="{ name: 'swift' }")
                        img(
                            src="@/assets/images/swift-mockups/smockup.jpg",
                            data-cursor-shrink
                        )
                    h1 Swift POS System
                    p Swift aims to create a convenient, flexible, and scalable interface suitable for both customers and restaurants giving users the opportunity to order, track and pay for their food immediately.

        #webdesign.section(data-anchor="web")
            .title
                .sub-heading
                    span.line
                    h2 web&nbsp;
                        span.red design
                h1 Created with&nbsp;
                    span.red passion
                    span ,&nbsp;
                    span.red dedication&nbsp;
                    span and a lot of&nbsp;
                    span.red coffee
                    span .
                //- h1 Web
                //- h1.red Design
                //- .sub-heading
                //-     span.line
                //-     h2 Created with passion, dedication and a lot of coffee.
                p.description We identify and create your brand for an online showcase for your entire audience to see. We chuck out the norms and bring in something that is completely unique to your brand.
            .examples
                .preview
                    router-link.img-wrapper(:to="{ name: 'vitaminsea' }")
                        img(
                            src="@/assets/images/vitaminsea/Mockup.jpg",
                            data-cursor-shrink
                        )
                    h1 VitaminSea
                    p VitaminSea is an accommodation-sharing website dedicated to showcasing the latest beachside properties and facilitating an easy-to-use booking system.
                .preview
                    router-link.img-wrapper(:to="{ name: 'diamond' }")
                        img(
                            src="@/assets/images/diamond/pioneer-mockup.jpg",
                            data-cursor-shrink
                        )
                    h1 Pioneer Diamond Tendering Platform
                    p The Pioneer Tendering platform was developed from the ground up to offer an easy-to-use and secure platform where suppliers can tender large amounts of diamonds to potential buyers.
        #production.section.white(data-anchor="production")
            .title
                .sub-heading
                    span.line
                    h2 film&nbsp;
                        span.red production
                h1 Showcase the best of&nbsp;
                    span.red your company&nbsp;
                    span with real reels.
                //- h1 Film
                //- h1.red Production
                //- .sub-heading
                //-     span.line
                //-     h2 Showcase the best of your company with real reels.
                p.description From trailers to hype videos to full-blown films, we create the most exciting cinematic experiences your audience will ever see.
            .examples
                .preview.landscape
                    router-link.img-wrapper(:to="{ name: 'blink' }")
                        img(
                            src="@/assets/images/blink/blink-poster.png",
                            data-cursor-shrink
                        )
                    h1 Blink
                    p Open the book and release the shadows. If it lets you see it, whatever you do, do not blink.
        #development.section(data-anchor="development")
            .title
                .sub-heading
                    span.line
                    h2 game&nbsp;
                        span.red development
                h1 Immerse yourself into&nbsp;
                    span.red your own&nbsp;
                    span 2D or 3D environment.
                //- .sub-heading
                //- h1 Game
                //- h1.red Development
                //- .sub-heading
                //-     span.line
                //-     h2 Immerse yourself into your own 2D or 3D environment.
                p.description We create interactive environments just the way you like it. Whether it is a 2D Platformer or a 3D Virtual Reality environment, we got you covered!
            .examples.games
                .preview.test
                    router-link.img-wrapper(:to="{ name: 'dawn' }")
                        img(
                            src="@/assets/images/dawn/dawn.png",
                            data-cursor-shrink
                        )
                    h1 Dawn
                    p 
                        | Dawn is a first person puzzle game set in a sci-fi environment.
                        | It combines puzzle mechanics along with the concept
                        | of colour to interact with the objects around you
                        | to complete the puzzle.
                .preview
                    router-link.img-wrapper(:to="{ name: 'rusted' }")
                        img.defaultImg(
                            src="@/assets/images/rusted/rusted-poster.png",
                            data-cursor-shrink
                        )
                    h1 Rusted
                    p 
                        | Rusted is a 2D platformer game developed in Unity Game Engine.
                        | It features 3 different levels that each take place in beautifully
                        | designed environments that contain their own unique obstacles and
                        | enemies with different abilities and attacking methods.

        .section(data-anchor="contact")
            .section-wrapper
                .section-inner-wrapper
                    .section-content-container
                        h1.section-title Let us help bring your ideas to market!
                        VRow.section-content-wrapper
                            VCol(:variants="['xs-12', 'md-6']")
                                .section-subtitle
                                    span.line
                                    | You can find us at
                                .section-content
                                    p.contact-info
                                        | 27 George Stohmarr Street, #[br]
                                        | Brooklyn, #[br]
                                        | Pretoria Central, 0122 #[br]
                                        | South Africa
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Contact us
                                .section-content
                                    a.contact-info-link(
                                        href="mailto:hello@influx.studio"
                                    ) hello@influx.studio
                                    a.contact-info-link(
                                        href="tel:+27 12 345 6789"
                                    ) +27 12 345 6789
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Follow our journey
                                .section-content
                                    a.contact-info-social(
                                        href="https://www.facebook.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/facebook.svg")
                                    a.contact-info-social(
                                        href="https://www.twitter.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/twitter.svg")
                                    a.contact-info-social(
                                        href="https://www.instagram.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/insta.svg")
                                    a.contact-info-social(
                                        href="https://www.linkedin.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/linkedin.svg")
                            VCol(:variants="['xs-12', 'md-6']") 
                                .section-content.min-content.remove-top-margin
                                    .contact-form-card
                                        img.dot-pattern(
                                            src="@/assets/dot-pattern.svg"
                                        )
                                        .section-subtitle
                                            span.line
                                            | Send us a message
                                        ContactForm

        //- .section.cream
        //-     VGrid(variant="container").container
        //-         VRow.contact-us
        //-             VCol(variant="xs-12")
        //-                 h1.align-center.contact-description Want to work with us?
        //-                 div.align-center
        //-                     router-link.contact-button.primary-button(:to="{ name: 'home', query: { c: true } }", data-cursor-shrink) Start A Project

    .static-elements
        .static-wrapper-inner.navigation-container
            Navigation.staticnav
        .static-wrapper-inner.static-footer
            p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
import ContactForm from "@/components/contactform.vue";
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";

export default {
    name: "Works",
    metaInfo: {
        title: "Portfolio Works",
    },
    components: {
        Navigation,
        ContactForm,
    },
    data: function () {
        return {
            fpOptions: {
                licenceKey: "",
                // menu: "#menu",
                onLeave: this.changedSlide,
                navigation: true,
                navigationTooltips: [
                    "Landing",
                    "Mobile",
                    "Web",
                    "Film",
                    "Games",
                    "Contact",
                ],
                lockAnchors: true,
                scrollHorizontally: true,
                responsiveWidth: 1280,
            },
            fullpageDots: null,
            isAtTop: true,
            isAtBottom: false,
        };
    },
    methods: {
        changedSlide(origin, destination) {
            if (destination.index > 0) this.isAtTop = false;
            else this.isAtTop = true;

            if (destination.index < 5) this.isAtBottom = false;
            else this.isAtBottom = true;

            if (destination.index == 0)
                this.fullpageDots.classList.add("hidden");
            else this.fullpageDots.classList.remove("hidden");
        },
        scrollTo(name) {
            console.log("ScrollTo " + name);
            this.$refs.fullpage.api.moveTo(name, 0);
        },
        // BackToTop() {
        //     this.$refs.fullpage.api.moveTo("landing", 0);
        // },
        // SlideUp() {
        //     this.$refs.fullpage.api.moveSectionUp();
        // },
        // SlideDown() {
        //     this.$refs.fullpage.api.moveSectionDown();
        // },
        // nextTeamMember() {
        //     this.$refs.teamsCarousel.next();
        // },
        // prevTeamMember() {
        //     this.$refs.teamsCarousel.prev();
        // },
    },
    mounted() {
        this.fullpageDots = document.getElementById("fp-nav");
        this.fullpageDots.classList.add("hidden");
        // new ServiceGallery(this.$refs.parallaxInject);
        new Parallax(this.$refs.parallax, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        // let scrollParam = this.$route.query.scrollTo;
        // if (scrollParam != null && scrollParam != undefined) {
        //     this.$refs.fullpage.api.moveTo(scrollParam, 0);
        // }

        EventBus.$emit("rescan-cursor");
        this.$refs.fullpage.build();
    },
};
</script>

<style lang="scss" scoped>
.section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: -10;
}
.main-wrapper {
    display: flex;
    flex-flow: column nowrap;
    // justify-content: space-between;
    position: relative;
    // height: 100vh;
    overflow: hidden;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    // padding: 0 $body-padding-desktop-x;
    z-index: 1;
}
.nav-wrapper,
.section {
    margin-top: $body-padding-desktop-y;
}
.project-menu {
    margin-top: 2vw;
    // margin-bottom: 7rem;
    display: flex;
    flex-direction: row;
    .menu-item {
        font-size: 0.7vw;
        font-family: "Muli", Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        padding-right: 2vw;
        line-height: 1vw;
        display: flex;
        align-items: center;

        a.label {
            color: $cl-grey;
            opacity: 0.8;
            transition: opacity 150ms ease-in-out;

            &:hover {
                opacity: 1;
            }

            &.active {
                position: relative;
                &::after {
                    bottom: 0;
                    height: 0.1vw;
                    background-color: $cl-red;
                    left: 0;
                    // top: 2vw;
                    margin-top: 2vw;
                    width: 3vw;
                    content: "";
                    position: absolute;
                }
            }
        }
    }
}
.landing {
    // background-color: $cl-cream !important;
    display: flex;
    align-items: center;
    // position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 $body-padding-desktop-x;
    height: 100%;
}
.section {
    // padding: 0 $body-padding-desktop-x;
    background-color: none;
    height: 30vw;
    margin: 0;
    padding: 2vw;
    // vertical-align: middle;
    // border: 2px solid red;

    .main-title {
        width: 40%;
        height: 100%;
        margin-left: 2vw;
        padding: 0 $body-padding-desktop-x;
        display: inline-flex;
        flex-flow: column nowrap;
        justify-content: center;
        float: left;

        h1 {
            // margin: 0 auto;
            // width: 90%;
            // text-align: right;
            text-align: left;
            font-size: 2.5vw;
            display: inline;
            // border: 1px solid red;
        }
        .red {
            color: $cl-red;
            // display: flex;
        }

        .page-description {
            margin-top: 2vw;
        }
    }
    .service-images {
        width: 50%;
        height: 100%;
        display: flex;
        // float: left;
        position: relative;
        @include respond-below(lg) {
            height: auto;
            margin-bottom: 2vw;
        }

        img {
            width: 100%;
            height: auto;
        }

        .service-images-wrapper {
            position: relative;
            width: 90%;
            height: 65%;
            top: 12.5%;
            // border: 1px solid red;
            // padding-top: 56.25%;

            @include respond-below(lg) {
                width: 100%;
                height: auto;
            }

            .layer-labels {
                filter: blur(5px);
            }

            .layer-gridlines {
                z-index: 0;
            }

            .layer-graphics {
                z-index: 1;
            }

            .layer-images {
                z-index: 2;
            }

            .layer-labels {
                z-index: 3;
            }

            .layer-labels-text {
                z-index: 4;
            }
        }
    }

    // .title-section-image {
    //     // margin-right: 5vw;
    //     margin-top: 4vw;
    //     margin-left: 20vw;
    //     position: relative;
    //     width: 20%;
    //     float: left;

    //     .main-image {
    //         max-width: 16vw;
    //         position: relative;
    //         z-index: 3;
    //     }

    //     .dot-pattern {
    //         position: absolute;
    //         width: 70%;
    //         margin-left: 5vw;
    //         margin-top: 10vw;
    //         z-index: 1;
    //     }

    //     .outline-square {
    //         position: absolute;
    //         width: 75%;
    //         height: 100%;
    //         border: 1px solid $cl-grey;
    //         margin-top: 2vw;
    //         margin-left: -3vw;
    //         z-index: 1;
    //     }

    //     .filled-squares {
    //         width: 100%;
    //         height: 100%;
    //         position: absolute;
    //         top: 0;
    //         right: 0;
    //         z-index: 2;

    //         &::before {
    //             content: "";
    //             position: absolute;
    //             width: 9.6rem;
    //             height: 9.6rem;
    //             bottom: -2.4rem;
    //             right: -2.4rem;
    //             background-color: $cl-red;
    //         }

    //         &::after {
    //             content: "";
    //             position: absolute;
    //             width: 16rem;
    //             height: 16rem;
    //             top: -3.6%;
    //             left: -3.6rem;
    //             border: 1px solid $cl-grey;
    //         }
    //     }
    // }

    .title {
        width: 40%;
        height: 100%;
        margin-left: 2vw;
        padding: 0 $body-padding-desktop-x;
        display: inline-flex;
        flex-flow: column nowrap;
        justify-content: center;
        line-height: 3vw;
        // text-align: center;
        // border: 5px solid red;
        // top: 0;
        // position: absolute;

        .sub-heading {
            display: flex;
            width: 50%;
            align-items: center;
            margin: 0;
            margin-top: -3vw;
            padding: 0;

            h2 {
                font-size: 1vw;
                font-weight: 600;
                line-height: 2vw;
            }

            .line {
                flex-grow: 1;
                background-color: $cl-grey;
                height: 0.05vw;
                margin-right: 1vw;
            }
        }

        h1 {
            font-size: 1.8vw;
            font-family: "Poppins";
            line-height: 2vw;
        }
        .red {
            color: $cl-red;
            text-indent: 0.3vw;
        }
        .description {
            margin-top: 2vw;
            line-height: normal;
            width: 80%;
            text-align: left;
            font-size: 0.9vw;
        }
    }
    .examples {
        width: 50%;
        height: 70%;
        overflow: hidden;
        margin: auto;
        top: 3vw;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        margin-right: 6vw;
        display: inline-flex;
        flex-flow: row nowrap;
        justify-content: center;
    }

    .games {
        height: 50%;
    }
    .preview {
        // border: 5px solid red;
        height: 100%;
        width: 45%;
        text-align: center;
        margin: 0 0.3vw;
        // display: inline;
        .img-wrapper {
            overflow: hidden;
            background-color: $cl-red;
            img {
                box-sizing: border-box;
                width: 100%;
                position: relative;
                transition: 0.3s;
                filter: grayscale(100%) contrast(150%) brightness(30%);
            }
        }

        .img-wrapper:hover img {
            // filter: grayscale(0%);
            // opacity: 1;
            transform: scale(1.1);
        }

        h1 {
            font-weight: 600;
            font-size: 1vw;
            margin-top: 1vw;
        }
        p {
            font-size: 0.8vw;
        }
    }

    .test {
        width: 50%;
    }

    .landscape {
        width: 90%;
    }
}
.section:hover .preview img {
    filter: grayscale(0%) contrast(100%) brightness(100%);
    // opacity: 0.5;
}
.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}

.cream {
    background-color: $cl-cream;
    position: relative;
    width: 100%;
}
.container {
    @media (min-width: 1200px) and (max-width: 1599px) {
        max-width: 80%;
    }

    @media (min-width: 1600px) {
        max-width: 75%;
    }

    position: relative;

    .section-title {
        color: $cl-grey;
        font-size: 2vw;
        font-weight: 400;
        font-family: "Poppins", Helvetica, sans-serif;
        margin-top: 0vw;
        // border: 1px solid red;

        &.line {
            position: relative;
            &::after {
                bottom: 0;
                height: 3px;
                background-color: $cl-red;
                left: 0;
                width: 5rem;
                content: "";
                position: absolute;
            }
        }

        &.light-text {
            color: white;
        }
    }

    .align-center {
        display: flex;
        justify-content: center;
        margin-bottom: 5rem;
        margin-top: 1.5rem;

        .percentage {
            font-size: 4rem;
            color: $cl-red;
        }

        .results-description {
            font-size: 1.5rem;
            font-weight: 500;
        }
    }
    .contact-us {
        display: flex;
        justify-content: center;
        margin-bottom: 2vw;
        margin-top: 2vw;
        // border: 1px solid red;

        .contact-description {
            font-size: 1.8vw;
            font-weight: 600;
            margin-top: 2vw;
            margin-bottom: 1vw;
            // border: 1px solid red;
        }

        .contact-button {
            // background-color: $cl-cream;
            margin-top: 0;

            &:hover {
                background-color: $cl-red;
            }
        }

        &.align-center {
            display: flex;
            justify-content: center;
        }
    }
}
.section-inner-wrapper {
    margin-top: -5vw;
}
</style>